var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnrolledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2706 4.94629C54.8619 4.94629 69.1281 19.2125 69.1281 36.8038C69.1281 54.3951 54.8619 68.6613 37.2706 68.6613C19.6793 68.6613 5.41309 54.3951 5.41309 36.8038C5.41309 19.2125 19.6793 4.94629 37.2706 4.94629ZM30.655 47.1513L22.8555 39.3454C21.5267 38.0158 21.5264 35.8477 22.8555 34.5184C24.1848 33.1894 26.3626 33.1977 27.6822 34.5184L33.1808 40.0213L46.8594 26.3427C48.1888 25.0134 50.3571 25.0134 51.6862 26.3427C53.0155 27.6717 53.0136 29.8419 51.6862 31.1694L35.5903 47.2653C34.2628 48.5927 32.0926 48.5946 30.7635 47.2653C30.7262 47.228 30.6902 47.19 30.655 47.1513Z",
    fill: "#00BA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrolledIcon);
export default __webpack_public_path__ + "static/media/enrolledIcon.33eec04cf3c35e2eecd30a681ef6905f.svg";
export { ForwardRef as ReactComponent };